<template>
  <div
    class="quantity"
  >
    <div class="quantity__action minus">
      <button
        type="button"
        :disabled="props.data.disabled"
        :class="[
          props.data.disabled ? '!bg-surface-200' : ''
        ]"
        @click="decrement"
      >
        -
      </button>
    </div>

    <div class="quantity__field">
      <InputMask
        :id="props.data.id"
        v-model="quantity"
        class="rounded-none text-center ring-transparent focus:ring-transparent"
        :mask="props.data.maska"
        slot-char=""
        :auto-clear="false"
        :disabled="props.data.disabled"
        :autocomplete="props.data.name"
        :placeholder="props.data.placeholder"
        :min="props.data.min"
        :max="props.data.max"
        :class="props.data.errorMessage ? 'invalid' : 'valid'"
        @change="handleInput(quantity)"
      />
    </div>
    <div class="quantity__action plus">
      <button
        type="button"
        :disabled="props.data.disabled"
        :class="[
          props.data.disabled ? '!bg-surface-200' : ''
        ]"
        @click="increment"
      >
        +
      </button>
    </div>
  </div>
</template>

<script setup>
/**
* Props
*/
const props = defineProps({
  data: {
    type: Object,
    default: null
  }
})

const min = props.data.min ? parseInt(props.data.min) : 1
const max = parseInt(props.data.max)
const quantity = ref(min)

/**
* Emits
*/
const emit = defineEmits(['returnData'])

/**
* Main Logic
*/
onMounted(() => {
  quantity.value = props.data.formData[props.data.name] 
    ? props.data.formData[props.data.name] * 1 
    : min

  if (!quantity.value) {
    quantity.value = 1
  }
})

/**
* Handle Input
*/
const handleInput = (newQuantity) => {
  let returnQuantity = newQuantity * 1

  if (parseInt(quantity.value) < parseInt(min) || returnQuantity < parseInt(min) || returnQuantity < 1) {
    returnQuantity = min
  } else if (parseInt(quantity.value) > max || returnQuantity > max) {
    returnQuantity = max
  }

  quantity.value = returnQuantity

  emit('returnData', quantity.value)
}

/**
* Increment Quantity
*/
const increment = () => {
  if (quantity.value * 1 + 1 <= max) {
    const newQuantity = quantity.value * 1 + 1
    handleInput(newQuantity)
  }
}

/**
* Decrement Quantity
*/
const decrement = () => {
  if (quantity.value * 1 - 1 >= min) {
    const newQuantity = quantity.value * 1 - 1
    handleInput(newQuantity)
  }
}
</script>

<style lang="scss" scoped>
.quantity {
  display: flex;
  max-width: 160px;
  &__action {
    flex: 1 1 40px;
    button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 40px;
      font-size: 0;
      background: #fff;
      border: 1px solid #e3e7eb;
      outline: none;
      cursor: pointer;
      &:disabled {
        cursor: default;
      }
      &:before,
      &:after {
        background: rgba(#131313, .6);
      }
      &:hover {
        &:before,
        &:after {
          background: rgba(#131313, 1);
        }
      }
    }
    &.minus {
      button {
        border-right: none;
        &:before {
          content: "";
          display: block;
          width: 10px;
          height: 2px;
        }
      }
    }
    &.plus {
      button {
        border-left: none;
        &:before {
          content: "";
          position: absolute;
          display: block;
          width: 10px;
          height: 2px;
        }

        &:after {
          content: "";
          position: absolute;
          display: block;
          width: 2px;
          height: 10px;
        }
      }
    }
  }
  &__field {
    flex: 1 1 calc(100% - 90px);
    input {
      height: 40px!important;
      text-align: center;
      &:hover,
      &:active {
        border-color: inherit;
      }
      &:disabled {
        &:hover,
        &:active {
          border-color: inherit;
        }
      }
    }
  }
}
</style>
